import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";

const SupervisorCompanySwitcher = () => {
  const { user, switchSupervisorCompany } = useContext(AuthContext);
  const [companies, setCompanies] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");

  // Buscar empresas ao montar
  useEffect(() => {
    if (!user?.supervisorId) return;

    const fetchCompanies = async () => {
      try {
        const { data } = await api.get("/supervisor/my-companies");
        setCompanies(data || []);
      } catch (error) {
        // Silencioso
      }
    };

    fetchCompanies();
  }, [user?.supervisorId]);

  // Se não é supervisor, não renderizar
  if (!user?.supervisorId) {
    return null;
  }

  // Encontrar nome da empresa ativa
  const activeCompany = companies.find((c) => c.companyId === user?.companyId);
  const activeCompanyName = activeCompany?.companyName || "Trocar empresa";

  // Filtrar empresas pela busca
  const filteredCompanies = companies.filter((company) =>
    company.companyName.toLowerCase().includes(search.toLowerCase())
  );

  // Handlers
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSearch("");
  };

  const handleSelectCompany = (companyId) => {
    if (companyId !== user?.companyId) {
      switchSupervisorCompany(companyId);
    }
    handleClose();
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSearchKeyDown = (event) => {
    event.stopPropagation();
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        onClick={handleClick}
        startIcon={<ApartmentIcon />}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          color: "#fff",
          fontWeight: 600,
          fontSize: "13px",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
      >
        {activeCompanyName}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableAutoFocusItem
        PaperProps={{
          sx: {
            width: "300px",
            backgroundColor: "#fff",
            borderRadius: 1,
          },
        }}
      >
        {/* Cabeçalho */}
        <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              fontWeight: 600,
              fontSize: "11px",
              textTransform: "uppercase",
              color: "#333",
            }}
          >
            Empresa Ativa
          </Typography>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              marginTop: "4px",
              fontSize: "11px",
              color: "#999",
            }}
          >
            Empresas ativas ({companies.length})
          </Typography>
        </Box>

        {/* Campo de busca */}
        <Box sx={{ p: 1.5, borderBottom: "1px solid #f0f0f0" }}>
          <TextField
            placeholder="Buscar empresa..."
            size="small"
            fullWidth
            value={search}
            onChange={handleSearchChange}
            onKeyDown={handleSearchKeyDown}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "18px", color: "#999" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "13px",
              },
            }}
          />
        </Box>

        {/* Lista de empresas */}
        <Box sx={{ maxHeight: 320, overflowY: "auto" }}>
          {filteredCompanies.length > 0 ? (
            filteredCompanies.map((company) => (
              <MenuItem
                key={company.companyId}
                onClick={() => handleSelectCompany(company.companyId)}
                selected={company.companyId === user?.companyId}
                sx={{
                  padding: "10px 16px",
                  fontSize: "13px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Typography sx={{ fontSize: "13px" }}>
                    {company.companyName}
                  </Typography>
                  {company.companyId === user?.companyId && (
                    <CheckIcon sx={{ fontSize: "18px", color: "#1976d2" }} />
                  )}
                </Box>
              </MenuItem>
            ))
          ) : (
            <Box sx={{ p: 2, textAlign: "center" }}>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#999",
                }}
              >
                Nenhuma empresa encontrada
              </Typography>
            </Box>
          )}
        </Box>
      </Menu>
    </>
  );
};

export default SupervisorCompanySwitcher;
